import React, { FC, useState } from 'react';
import clsx from 'clsx';
import { IPaymentGatewayItemProps, PAYMENT_GATEWAY_CHECKBOX_NAMES } from './PaymentGatewayTableRow';
import { setPaymentGateway } from '../../../store/payments/actions/providers';

interface Props extends IPaymentGatewayItemProps {
	fieldName: string;
	value: boolean;
}

export const PaymentGatewayCheckbox: FC<Props> = (props) => {
	const { value, fieldName, ...itemProps } = props;

	const [localIsChecked, setLocalIsChecked] = useState<boolean>(value);
	const [loading, setLoading] = useState<boolean>(false);

	const canChange = fieldName !== PAYMENT_GATEWAY_CHECKBOX_NAMES.SANDBOX;

	const handleInputChange = async (): Promise<void> => {
		try {
			setLoading(true);
			const params = { ...itemProps };
			setLocalIsChecked(!localIsChecked);
			if (fieldName === PAYMENT_GATEWAY_CHECKBOX_NAMES.MIT_SUPPORT || fieldName === PAYMENT_GATEWAY_CHECKBOX_NAMES.CIT_SUPPORT) {
				params.capabilities[fieldName] = !localIsChecked;
			} else {
				params[fieldName] = !localIsChecked;
			}
			await setPaymentGateway(params);
			setLoading(false);
		} catch (e) {
			console.log(e);
			setLocalIsChecked(localIsChecked);
			setLoading(false);
		}
	};

	return (
		<div className='form-check form-check-sm form-check-custom form-check-solid'>
			<input
				className={clsx('form-check-input', !canChange && 'cursor-not-allowed')}
				type='checkbox'
				checked={localIsChecked}
				onChange={handleInputChange}
				disabled={loading || !canChange}
			/>
		</div>
	);
};
